import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaSearch } from 'react-icons/fa';

const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 80px 0 30px;
  width: 100%;
  box-sizing: border-box;
  position: relative;

  @media (min-width: 769px) and (max-width: 1280px) {
    padding: 0 15px;
  }

  @media (max-width: 768px) {
    padding: 0 15px;
    margin: 50px 0 30px;
  }
`;

const SearchInput = styled.input`
  width: 100%; 
  padding: 15px;
  padding-left: 45px;
  font-size: 16px;
  border-radius: 15px;
  border: 1px solid rgba(46, 46, 46, 0.2);
  background-color: white;
  color: rgba(46, 46, 46, 0.7);
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.3s;
  max-width: 100%;

  &:focus {
    border-color: rgba(46, 46, 46, 0.4);
  }

  &::placeholder {
    color: rgba(46, 46, 46, 0.5);
  }

  @media (max-width: 768px) {
    &::placeholder {
      text-align: center;
    }
  }
`;

const SearchIcon = styled.div`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(46, 46, 46, 0.5);
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    left: 30px;
  }
`;

function SearchBar({ onSearch, placeholder }) {
  const [query, setQuery] = useState('');
  const [defaultPlaceholder, setDefaultPlaceholder] = useState('Search for stock music by categories, moods, artist styles...');

  useEffect(() => {
    const updatePlaceholder = () => {
      if (window.matchMedia('(max-width: 768px)').matches) {
        setDefaultPlaceholder('Categories, moods, styles...');
      } else {
        setDefaultPlaceholder('Search for stock music by categories, moods, artist styles...');
      }
    };

    updatePlaceholder(); // Run on mount
    window.addEventListener('resize', updatePlaceholder); // Listen for window resize

    return () => {
      window.removeEventListener('resize', updatePlaceholder);
    };
  }, []);

  const handleSearch = (e) => {
    if (e.key === 'Enter' && query.trim()) {
      onSearch(query.trim());
    }
  };

  return (
    <SearchContainer>
      <SearchIcon>
        <FaSearch />
      </SearchIcon>
      <SearchInput
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleSearch}
        placeholder={placeholder || defaultPlaceholder}
      />
    </SearchContainer>
  );
}

export default SearchBar;